<template>
  <ComplianceStatusCell
    :data-test="`recruiter-compliance-status-${index}`"
    :completed="comp?.completed"
    :status="status"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import ComplianceStatusCell from '@/components/GraphqlDataTable/columns/Compliance/ComplianceStatusCell.vue'
import { complianceStatus } from '@/components/GraphqlDataTable/columns/Compliance/verifiedComplianceData'

const RecruiterComplianceStatusColumn = graphql(`
  fragment RecruiterComplianceStatusColumn on CompanyRecruiter {
    id
    verifiedCompliance: compliances(names: [VERIFIED_RECRUITER_COMPLIANCE]) {
      name
      completed
      data {
        ...VerifiedComplianceStatus
      }
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof RecruiterComplianceStatusColumn>
  index: number
}>()

const column = computed(() => useFragment(RecruiterComplianceStatusColumn, props.row))
const comp = computed(() => column.value.verifiedCompliance?.[0])
const status = computed(() => complianceStatus(comp.value?.data))
</script>
